<template>
  <div id="app">
    <!-- <ContactUs></ContactUs> -->
    <div
      class="viewer-images"
      ref="viewerImages"
      v-show="false"
      v-viewer="{ movable: false }"
    >
      <img :src="src" />
    </div>
    <!-- <router-view /> -->
    <!-- 无操作登出相关逻辑 -->
    <!-- <div v-show='maskShow' class="mask">
      <div class="tip">
        <i class="ivu-icon ivu-icon-android-alert" style="font-size:28px;color: orange;"></i>
        <div class="content">
          <div>由于您长时间未操作界面，系统已自动退出，请您重新登录。</div>
          <div class="second">{{second}} s</div>
        </div>
      </div>
    </div> -->
    <MainView />
  </div>
</template>

<script>
// import ContactUs from '@/components/common-temp/contact-us.vue'

// import {cookies} from '@/common/cookieUtils'

import MainView from "@/components/index.vue";
export default {
  name: "app",
  data() {
    return {
      scrollTop: 0,
      src: ""
      // clock:null,
      // maskShow:false,
      // second:3,
      // timer:null
    };
  },
  created() {
    this.$nextTick(() => {
      window.addEventListener("scroll", this.calculateScroll);
    });
  },
  mounted() {
    // 使用这种方式是因为window.addEventListener这种方式会触发两次，导致出现两个图片查看器
    window.onmessage = message => {
      this.handleMessage(message);
    };
  },

  // updated(){
  //   this.setClock()
  // },
  beforeDestroy() {
    window.removeEventListener("scroll", this.calculateScroll);
    // document.body.onclick = document.body.onkeydown= document.body.onmousemove = null
  },
  methods: {
    // 监听子iframe传递的图片url，并预览图片
    handleMessage(message) {
      this.src = message.data.url;
      console.log("src", this.src);
      if (this.src) {
        // 使用setTimeout是为了在图片加载结束后再执行图片预览，否则首次赋值页面刷新会导致图片查看器闪退（此处为坑）
        setTimeout(() => {
          this.show();
        }, 100);
      }
    },
    // 执行预览
    show() {
      this.$nextTick(() => {
        const vuer = this.$refs.viewerImages.$viewer;
        vuer.show();
      });
    },
    calculateScroll() {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.scrollTop = scrollTop;
    }
    // setTimer(){
    //   this.timer = setInterval(()=>{
    //     if(this.second){
    //       this.second--
    //     }
    //     if(!this.second){
    //       clearInterval(this.timer)
    //       this.timer = null
    //       this.maskShow = false
    //       this.$router.push({path: 'login'})
    //     }
    //   },1000)
    // },
    // setClock(){
    //   if(document.body.onclick){
    //     return
    //   }
    //   let clock = ()=>{
    //     clearTimeout(this.clock)
    //     this.clock = setTimeout(()=>{
    //       localStorage.removeItem('tenant')
    //       localStorage.removeItem('project')
    //       cookies.deleteAuthorization()
    //       cookies.delTenantProject()
    //       this.maskShow = true
    //       this.second = 3
    //       this.setTimer()
    //     },1000*60*30)
    //   }
    //   cookies.getAuthorization().then(token=>{
    //     if(!token){return}
    //     document.body.onclick = document.body.onkeydown= document.body.onmousemove = clock
    //   })
    // }
  },
  components: {
    // ContactUs
    MainView
  }
};
</script>

<style lang="less">
// .mask{
//   position: absolute;
//   z-index:999999;
//   width: 100%;
//   height: 100%;
//   background: rgba(0,0,0,0.4);
//   .tip{
//     width: 280px;
//     top: 100px;
//     right: 0;
//     position: absolute;
//     padding: 10px;
//     color: #000;
//     font-weight: 500;
//     line-height: 30px;
//     font-size: 15px;
//     background-color: #fff;
//     .second{
//       float: right;
//     }
//     .content{
//       margin-left: 10px;
//     }
//   }
// }
#app {
  font-family: "微软雅黑", "Microsoft Yahei", Helvetica, "Lucida Grande",
    sans-serif;
}

/* chrome 滚动条自定义*/
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #bbb;
}
::-webkit-scrollbar-track {
  border-radius: 0;
  background: #e1e1e1;
}

/*控制消息提醒组件*/
.ivu-message {
  z-index: 10000;
}
/*报错信息组件*/
.ivu-notice {
  z-index: 10000 !important;
}
.ivu-notice-icon-error,
.ivu-notice-icon-warning,
.ivu-notice-icon-success,
.ivu-notice-icon-info {
  font-size: 18px !important;
  margin-left: 20px !important;
}
.ivu-notice-title {
  margin-left: 45px !important;
}
.ivu-notice-desc {
  word-wrap: break-word;
  margin-left: 24px !important;
}
/*解决确认提示框被模态框遮挡问题*/
.swal2-container {
  z-index: 10001;
}
li,
ol {
  list-style: none;
}
a {
  text-decoration: none;
}
label {
  margin: 0;
}
.ivu-modal-mask {
  z-index: 3000;
}
.ivu-modal-wrap {
  z-index: 3000;
  top: 4.7rem;
}
.modal-dialog {
  top: 15%;
}

/*v-select样式*/
.v-select /deep/ input[type="search"],
.v-select /deep/ input[type="search"]:focus {
  height: 30px !important;
}

.v-select /deep/ .open-indicator:before {
  border-width: 0 !important;
  content: "\f104";
}

.v-select /deep/ .open-indicator {
  position: absolute;
  top: 50%;
  right: 6px;
  line-height: 1;
  margin-top: -14px;
  font-size: 14px;
  color: #80848f;
  transition: all 0.3s ease-in-out;

  display: inline-block;
  font-family: Ionicons;
  font-style: normal;
  font-weight: 400;
  line-height: 1;

  transform: rotate(-134deg);
  -ms-transform: rotate(-134deg); /* IE 9 */
  -moz-transform: rotate(-134deg); /* Firefox */
  -webkit-transform: rotate(-134deg); /* Safari 和 Chrome */
  -o-transform: rotate(-134deg); /* Opera */
}

.v-select /deep/ .dropdown-menu {
  font-size: 13px !important;
  li {
    margin: 0;
    line-height: normal;
    clear: both;
    color: #595959;
    white-space: nowrap;
    list-style: none;
    cursor: pointer;
    transition: background 0.2s ease-in-out;
  }
}

.v-select /deep/ .selected-tag {
  margin: 2px 1px 0 3px;
}

// 临时存放块状区域圆角样式--开始
.ui-block:first-child {
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
}
.ui-block:last-child {
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
}

/*兼容性处理*/
//  textarea在Edage下黑边框处理
textarea {
  border: 1px solid #e9e9e9;
}

/* element组件样式全局重置 */
// 穿梭框样式修正
.el-transfer-panel__item {
  display: block;
}

// 万能清浮动
.clearFix:after {
  content: "";
  display: table;
  clear: both;
}
</style>



// WEBPACK FOOTER //
// src/App.vue